export function getPrintSettings() {	

	let printSettings={
		paperSize:'letter',
		
	}

	const settingsFromLocalStorage = JSON.parse(localStorage.getItem('printSettings'))

	if(settingsFromLocalStorage ){	
		if(settingsFromLocalStorage.paperSize || !settingsFromLocalStorage.paperSize){
			printSettings.paperSize=settingsFromLocalStorage.paperSize
		}
		
	}

	return printSettings

}

